import * as React from 'react';

const DragIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 23" className="w-6 h-6 m-1">
    <g clipPath="url(#clip0)">
      <path
        fill="#718096"
        d="M3.77 10.37L5.66 8.5a1.33 1.33 0 011.88 0l1.89 1.88a1.33 1.33 0 010 1.89l-1.89 1.88a1.33 1.33 0 01-1.88 0l-1.89-1.88a1.34 1.34 0 010-1.89zm.94.94L6.6 13.2l1.89-1.89L6.6 9.43 4.71 11.3zM8.5 5.66l1.88-1.89a1.33 1.33 0 011.89 0l1.88 1.89a1.33 1.33 0 010 1.88l-1.88 1.89a1.33 1.33 0 01-1.89 0L8.5 7.54a1.34 1.34 0 010-1.88zm.94.94l1.88 1.89L13.2 6.6l-1.9-1.89L9.43 6.6zm-.94 8.49l1.88-1.9a1.33 1.33 0 011.89 0l1.88 1.9a1.33 1.33 0 010 1.88l-1.88 1.89a1.33 1.33 0 01-1.89 0L8.5 16.97a1.34 1.34 0 010-1.88zm.94.94l1.88 1.88 1.89-1.88-1.89-1.89-1.88 1.89zm3.77-5.66l1.88-1.88a1.33 1.33 0 011.9 0l1.88 1.88a1.33 1.33 0 010 1.89l-1.89 1.88a1.33 1.33 0 01-1.89 0l-1.88-1.88a1.34 1.34 0 010-1.89zm.94.94l1.89 1.89 1.88-1.89-1.88-1.88-1.89 1.88z"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path
          fill="#fff"
          d="M0 0h16v16H0z"
          transform="rotate(-45 13.66 5.66)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default DragIcon;



// WEBPACK FOOTER //
// ./src/Pages/PageEditor/components/DragIcon.tsx